import styled from "@emotion/styled";

export const AccountDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 30px;
`;

export const UserSettingsContainer = styled.form`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: start;
  padding: 30px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;
  margin-bottom: 30px;

  @media only screen and (min-width: 992px) {
    flex-wrap: nowrap;
  }
`;

export const FirstUserSettingsContainer = styled(UserSettingsContainer)`
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  /* box-shadow: #56a2e98f; */
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;

  @media only screen and (min-width: 992px) {
    width: 340px;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 30px;

  @media only screen and (min-width: 992px) {
    width: 500px;
  }
`;

export const UserName = styled.div`
  border-bottom: 1px solid lightgray;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FieldsSection = styled.div`
  margin-top: 20px;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
`;

export const AccountTitleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0 8px;
`;
